import { useEffect, useRef, useState } from "react";
import Button from "@weave-design/button";
import IconButton from "@weave-design/icon-button";
import { Folder24 } from "@weave-design/icons";
import Input from "@weave-design/input";
import Label from "@weave-design/label";
import Modal from "@weave-design/modal";
import { WeaveDesignStylesheet } from "../../../../sharedTypes";
import "./linkedModelCard.css";

type Props = {
    linkModel: (file: File) => void;
    cancel: () => void;
};

export const LinkedModelFileSelector = ({ linkModel, cancel }: Props) => {
    const [file, setFile] = useState<File | null>(null);
    const [fileName, setFileName] = useState("");
    const fileInputElement = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setFile(null);
        setFileName("");
    }, []);

    const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            return;
        }
        const selectedFile = e.target.files[0];
        const name = selectedFile.name.toLowerCase();

        if (!name.endsWith(".rvt") && !name.endsWith(".ifc")) {
            return;
        }

        setFile(selectedFile);
        setFileName(name);
    };

    const onBrowseClick = () => {
        fileInputElement.current?.click();
    };

    const onCreateClick = () => {
        if (!file) {
            return;
        }
        linkModel(file);
    };

    return (
        <Modal open title="Upload linked model" onCloseClick={cancel} stylesheet={modalStyles}>
            <div className="linked-model-file-selector">
                <div>
                    <Label variant="top">RVT/IFC input file:</Label>
                    <div className="linked-model-file-selector__form">
                        <Input variant="box" value={fileName} disabled />
                        <div>
                            <label htmlFor="modelFileInput">
                                <IconButton
                                    icon={<Folder24 />}
                                    title="Choose rvt or ifc file"
                                    onClick={onBrowseClick}
                                />
                            </label>
                            <input
                                id="modelFileInput"
                                ref={fileInputElement}
                                type="file"
                                accept=".rvt,.ifc"
                                onChange={onFileChange}
                                style={{ display: "none" }}
                            />
                        </div>
                    </div>
                </div>

                <div className="linked-model-file-selector__actions">
                    <Button size="standard" title="Create" type="primary" onClick={onCreateClick} disabled={!file} />
                    <div className="linked-model-upload__spacer" />
                    <Button id="cancel_button" size="standard" title="Cancel" type="secondary" onClick={cancel} />
                </div>
            </div>
        </Modal>
    );
};

const modalStyles = (styles: WeaveDesignStylesheet) => ({
    ...styles,
    modal: {
        ...styles.modal,
        window: {
            ...styles.modal.window,
            width: "400px",
            height: "230px",
            top: "calc(50% - 115px)",
        },
        bodyContent: {
            ...styles.modal.bodyContent,
            overflow: "hidden", // no scrollbar
        },
    },
});